<script setup lang="ts">
import type { SubmitEventPromise } from 'vuetify';

import { reactive, ref } from 'vue';

import KSingleAutocompleteField from '@/components/fields/KSingleAutocompleteField.vue';
import useForm from '@/composables/useForm';
import { useStaticStore } from '@/stores/useStaticStore';
import { requiredValidationRule } from '@/helpers/validationRules';

export interface InitialData {
  driver?: number;
}

export interface ValidData {
  driver: number;
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
});
const emit = defineEmits<{
  submit: [event: SubmitEventPromise | null | undefined, formData: ValidData];
}>();

const staticStore = useStaticStore();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, function (event) {
  if (formData.driver == null) return;
  const validData: ValidData = {
    driver: formData.driver,
  };
  emit('submit', event, validData);
});

// TODO should it be here or should it be passed as a form prop?
// Show "name (code)" so a dispatcher can pick by remembered name or number;
// the selected value is still the driver code.
const driverItems = staticStore.getDrivers.map((driver) => ({
  value: driver.code,
  title: `${driver.full_name} (${driver.code})`,
}));
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.dispatchAssignDriverDialogForm"
    data-testid="dispatchAssignDriverDialogForm"
    @submit.prevent="handleSubmit"
  >
    <KSingleAutocompleteField
      v-model="formData.driver"
      label="Driver"
      :disabled="props.loading"
      :rules="[requiredValidationRule]"
      :class="$style.field"
      :items="driverItems"
      hide-details
      autofocus
      @keydown.enter="handleSubmit"
    />
    <input type="submit" class="hidden" :disabled="props.loading" />
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.dispatchAssignDriverDialogForm {
}
  .field {
  }
</style>
